import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "menu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "built-in-item" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "description"
}
const _hoisted_13 = ["accept"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Console = _resolveComponent("Console")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.showMenu)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "menu-button",
            class: _normalizeClass({'dark-mode': _ctx.darkMode}),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, _hoisted_5, 2))
        : _createCommentVNode("", true),
      (_ctx.showMenu)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            id: "menu-items",
            class: _normalizeClass({'dark-mode': _ctx.darkMode})
          }, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.darkMode = !_ctx.darkMode; _ctx.showMenu = false;})
            }, _toDisplayString(_ctx.darkMode ? 'Light Mode' : 'Dark Mode'), 1),
            _hoisted_6,
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showBuiltInMenu = true; _ctx.showMenu = false;})
            }, "Built-in Games"),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadFromFile()))
            }, "Load From File"),
            (_ctx.gameLoaded)
              ? (_openBlock(), _createElementBlock("br", _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.gameLoaded && _ctx.init)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveState()))
                }, "Save Game"))
              : _createCommentVNode("", true),
            (_ctx.gameLoaded && _ctx.init)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadState()))
                }, "Load Game"))
              : _createCommentVNode("", true),
            (_ctx.gameLoaded && _ctx.init)
              ? (_openBlock(), _createElementBlock("br", _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.gameLoaded)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 4,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.startGame && _ctx.startGame(...args)))
                }, _toDisplayString(_ctx.init ? "Restart Game" : "Start Game"), 1))
              : _createCommentVNode("", true),
            _hoisted_9,
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToInstructions('player_instructions')))
            }, "How To Play"),
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToInstructions('dev_instructions')))
            }, "How To Develop")
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.fateLoaded)
      ? (_openBlock(), _createBlock(_component_Console, {
          key: 0,
          init: _ctx.init,
          gameState: _ctx.gameState,
          onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.showMenu = false;})
        }, null, 8, ["init", "gameState"]))
      : _createCommentVNode("", true),
    (_ctx.gameLoaded && !_ctx.init)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: "start-game-overlay",
          class: _normalizeClass(["modal-outer", {'dark-mode': _ctx.darkMode}])
        }, [
          _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.startGame && _ctx.startGame(...args)))
          }, "Start Game")
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showBuiltInMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["modal-outer", {'dark-mode': _ctx.darkMode}]),
          onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.showBuiltInMenu = false; _ctx.selectedBuiltIn = null;})
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-inner", {'dark-mode': _ctx.darkMode}]),
            onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["built-in-item-list", {'dark-mode': _ctx.darkMode}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.builtInGames, (game) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => (_ctx.selectedBuiltIn = game), ["stop"])
                  }, _toDisplayString(game.name), 9, _hoisted_11),
                  (_ctx.selectedBuiltIn === game)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.selectedBuiltIn.description), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 256))
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass({disabled: !_ctx.selectedBuiltIn}),
              onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadBuiltIn && _ctx.loadBuiltIn(...args)), ["stop"]))
            }, "Load", 2)
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showInitMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          id: "init-menu",
          class: _normalizeClass(["modal-outer", {'dark-mode': _ctx.darkMode}]),
          onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.showInitMenu = false;})
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-inner", {'dark-mode': _ctx.darkMode}]),
            onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("button", {
              onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.showBuiltInMenu = true; _ctx.showInitMenu = false; _ctx.showMenu = false;})
            }, "Built-in Games"),
            _createElementVNode("button", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadFromFile()))
            }, "Load From File"),
            _createElementVNode("button", {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.goToInstructions('player_instructions')))
            }, "How To Play"),
            _createElementVNode("button", {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.goToInstructions('dev_instructions')))
            }, "How To Develop")
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      id: "load-file",
      ref: "fileInput",
      type: "file",
      accept: _ctx.fileType,
      name: "files[]",
      onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.loadFile($event)))
    }, null, 40, _hoisted_13)
  ], 64))
}